import { GraphQLError } from 'graphql';

export const isMissingWeddingWebsiteError = (error?: { graphQLErrors?: ReadonlyArray<GraphQLError> }) =>
  !!error?.graphQLErrors?.some(graphQLError => graphQLError.path?.[0] === 'weddingWebsite');
